import request from '@/utils/zsm-requets'
const comment = '/zsm/api/good/comment/'
/*
新增评价或修改评价
content 评价内容
goodId 产品id
goodName 产品名称
orderId 订单编号
score 评分
 */
export function saveComment(params) {
  return request({
    url: comment + 'save',
    method: 'post',
    params
  })
}

/*
查看评价列表
goodId 产品id
goodName 产品名称
orderId 订单编号
 */
export function listDataComment(params) {
  return request({
    url: comment + 'listData',
    method: 'post',
    params
  })
}

/*
删除评价列表
goodId 产品id
goodName 产品名称
orderId 订单编号
 */
export function deleteComment(params) {
  return request({
    url: comment + 'delete',
    method: 'post',
    params
  })
}
